import { defineComponent as B, useSlots as C, computed as n, useAttrs as _, createElementBlock as a, openBlock as s, normalizeClass as w, createBlock as x, createVNode as A, resolveDynamicComponent as N, mergeProps as R, withCtx as S, renderSlot as V, createCommentVNode as c, toDisplayString as u, unref as m } from "vue";
import { RevButtonBase as f } from "@ds/components/ButtonBase";
import { RevButtonIcon as D } from "@ds/components/ButtonIcon";
import { usePropsValidation as P } from "../../composables/usePropsValidation.js";
import T from "../../icons/generated/IconCross.vue2.js";
import { tw as t } from "../../utils/tailwind.js";
const $ = {
  key: 0,
  class: "body-2 pr-4"
}, j = {
  key: 1,
  class: "group-focus-visible-outline-default-hi rounded-sm body-2-link"
}, H = /* @__PURE__ */ B({
  name: "RevBanner",
  inheritAttrs: !1,
  __name: "Banner",
  props: {
    closeAlternativeText: {},
    cta: {},
    label: {},
    to: {}
  },
  emits: ["close"],
  setup(p, { emit: d }) {
    const o = p, v = d, h = C();
    P({
      "please, provide either props.label or a default slot": () => !h.default && !o.label
    });
    const b = n(() => {
      const e = t`bg-static-info-hi flex w-full items-center justify-center`, l = [
        t`cursor-pointer`,
        t`focus-within:bg-static-info-hi-hover hover:bg-static-info-hi-hover`,
        t`focus-within:no-underline hover:no-underline`,
        t`motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`
      ];
      return o.to ? [e, l] : e;
    }), g = n(() => [
      t`text-action-default-hi group flex-1 py-16 pl-24 text-left leading-none no-underline md:p-16 md:text-center`,
      o.cta && t`outline-none`,
      !o.cta && t`focus-visible-outline-default-hi`
    ]), r = n(() => o.to ? f : "div"), i = _(), y = n(() => r.value === f ? {
      ...i,
      to: o.to
    } : i);
    function k(e) {
      v("close", e);
    }
    return (e, l) => (s(), a("aside", {
      class: w(b.value)
    }, [
      (s(), x(N(r.value), R({ class: g.value }, y.value), {
        default: S(() => [
          V(e.$slots, "default"),
          e.label ? (s(), a("span", $, u(e.label), 1)) : c("", !0),
          e.cta ? (s(), a("span", j, u(e.cta), 1)) : c("", !0)
        ]),
        _: 3
      }, 16, ["class"])),
      A(m(D), {
        "aria-label": e.closeAlternativeText,
        class: "mr-8",
        icon: m(T),
        variant: "secondary",
        onClick: k
      }, null, 8, ["aria-label", "icon"])
    ], 2));
  }
});
export {
  H as default
};
